import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "mr-2 underline break-all" }

import { UiButton } from '@/components/common/ui'
import { useNotifications } from '@/composables/useNotifications'

export interface IPropsTheRemovableFileItem {
    name?: string
    disableRemove?: boolean
}

interface IEventUiButton {
    (e: 'click'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: { type: String, required: false },
    disableRemove: { type: Boolean, required: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    name?: string
    disableRemove?: boolean
}
const { pushSuccess } = useNotifications()





const handleClick = () => {
    pushSuccess('Plik usunięty pomyślnie')
    emit('click')
}

return (_ctx: any,_cache: any) => {
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.name), 1),
    _createVNode(_unref(UiButton), {
      disabled: props.disableRemove,
      class: "file-remove-button",
      "no-button-style": "",
      "show-tooltip": "",
      "tooltip-message": 'usuń',
      "confirmation-message": 'Czy na pewno usunąć plik?',
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconCross)
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})